import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Context } from '../context/Context'
import { homepageData } from "../Database/Database"
import {audioLogicFile} from "../audios/auidoPlayLogic";
import { reactLocalStorage } from 'reactjs-localstorage'
import axios from "axios";
import { getHeaders,body,base,redirect_url } from "../Config";
import queryString from "query-string";
import { commonText as text } from "../Database/Database";
import WindowSize  from "../utils/WindowSize";
import { SendGuiDataEvents } from "../lib/CommonScript";
import SermonLanguageModal from "../commonComponents/SermonLanguageModal";


export default function Home() {
    const [appConfigData , setAppConfigData] = useState();
    const { lang ,handleIsShowHeader,theme,handleShowLoader,verified,isNewUser, handleNewUser, handleVerifyUser, handleModal,showLoader,handleSideMenu} = useContext(Context);
    const [loadingImg,setLoadingImg] = useState(true);
    const loadingGif = require("../assets/loading.gif");
    const [imageState , setImageState] = useState(0);
    const [showSermonLangModal, setShowSermonLangModal] = useState(false);
    const [languageModalData, setLanguageModalData] = useState(null);

    const [width] = WindowSize()
    // let location = useLocation();
    // let params = queryString.parse(location.hash);
    // console.log("params >>>>>>>>>hereeeeeeeeeeeeee", params,location)

    // const uid=Object.values(params).toString("")
    // console.log(uid)


    let location = useLocation();
    let params = queryString.parse(location.hash)
    console.log("params", params)
    console.log("params.uid", params["/?uid"])
    const uid = params["/?uid"]
    // const uid = Object.values(params).toString("")
    console.log("uid",uid)

    // console.log(location.hash)
    // console.log(params)
    // let params = queryString.parse(location.search);
    // console.log("params >>>>>>>>>hereeeeeeeeeeeeee", params)

    // show back btn logic
    useEffect(() => {
        //send gui events
        let guiDataEvent = {};
        guiDataEvent["page"] = "homepage";
        guiDataEvent["event"] = "open";
        SendGuiDataEvents(guiDataEvent);
      }, []);


    useEffect(( ) => {
        handleIsShowHeader(false);
        return () => {
            handleIsShowHeader(true);
        };
    },[])

// in livexgames , checkSub is configured , such that koi bhi uid pass karo it returns the same response,
// the only case in which it is getting redirected is , when the use doesnot enter,
// console.log("checkSub log ------> 1")


    const checkSub = (uid) => {
        axios({
            method: 'post',
            url: base + "checkSub",
            data: JSON.stringify({'uid': uid}),
            headers: getHeaders()
            }
        ).then((resp) => {
            console.log("checkSub log ------> 1")
            if(resp.data.status !== '' && resp.data.status !== undefined){
                    if(resp.data.status == 'failed'){
                        console.log("status failed")
                        window.open(redirect_url,"_self")
                        // const modalData = {
                        //     title : text.modal.okay[lang],
                        //     body : `${resp.data.message}`,
                        //     btn : [ text.modal.okay[lang]]
                        //   }
                        // handleModal(modalData , true)
                        // handleVerifyUser(false)

                    }else if(resp.data.status === 'success'){
                        if(resp.data.subStatus === 'new'){
                            // handleNewUser(true)
                            window.open(redirect_url, "_self")
                        }else if(resp.data.subStatus === 'active'){
                            handleVerifyUser(true)
                        }else {
                            window.open(redirect_url, "_self")
                            // const modalData = {
                            //     title: text.modal.oops[lang],
                            //     body: `${resp.data.message}`,
                            //     btn: [text.modal.okay[lang]],
                            //     api: "checksub"
                            // }
                            // console.log("failed modal from home.js")
                            // handleModal(modalData, true);
                            // handleVerifyUser(false)
                        }
                    }
                }
                reactLocalStorage.set("subStatus",resp.data.subStatus)
                // set loader false
        }).then((error) => {
            console.log("error -----> ", error)
        })
    }

    useEffect(() => {
        if(uid !== '' && uid !== undefined){
            reactLocalStorage.set("uid",uid);
            checkSub(uid)
        }else{
            if(reactLocalStorage.get("uid") !== '' && reactLocalStorage.get("uid") !== undefined){
                checkSub(reactLocalStorage.get("uid"))
            }else{
                console.log("redirect user ----> home.js")
                // window.open(redirect_url,"_self")
                handleNewUser(true)
            }
        }
    },[])

    useEffect(() => {
        return () => {
            handleSideMenu(false);
        }
    },[])

    const getAppConfig = () => {
        handleShowLoader(true);
        axios({
            method : "post",
            url : base + "appConfig",
            data: body["postman"],
            headers: { ...getHeaders()},
        })
        .then((resp) => {
            // if (theme === "red") {
            //     resp.data.data.pop();
            //     resp.data.data.pop();
            // }
            console.log("home page resp --->",resp.data.configData)
            setAppConfigData(resp.data)
            // handleShowLoader(false);
        })
        .catch((error) => {
            console.log("error --->",error)
        })
    }

    console.log("get app c")
    useEffect(getAppConfig,[])


    function handleNewUserRedirect(){
        if (isNewUser) {
            console.log("redirect url --> ",appConfigData.subUrl)
            let guiDataEvent = {};
            guiDataEvent["page"] = "homepage";
            guiDataEvent["event"] = "redirect";
            SendGuiDataEvents(guiDataEvent);
            window.open(appConfigData.subUrl,"_self");
        }
    }

    const handleItemClick = (e, data) => {
        if (data.id === 10 || data.id === "10") {
            // Show language selection modal for sermon
            e.preventDefault();
            e.stopPropagation();
            if (isNewUser) {
                handleNewUserRedirect();
            } else {
            const langData = appConfigData?.language;
            console.log("Language data:", langData);
            setLanguageModalData(langData);
            setShowSermonLangModal(true);
            }
        } else {
            // Normal navigation behavior
            handleNewUserRedirect();
        }
    }



    useEffect(() => {
        if(imageState >= 6){
            handleShowLoader(false)
        }
    },[imageState])


    return (
        <div className={`min-h-screen w-full bg-cover bg-center bg-no-repeat ${theme === "red" ? "bg-red_bg_pic": "bg-green_bg_pic"} pt-16 max-width`}>
            <div className="grid grid-cols-2 px-4">
                {console.log("hello")}
                {

                    appConfigData && appConfigData.data.map((data, index) => {
                        {console.log("hello inside map")}
                        {console.log(data)}
                        return (
                            <div key={index} className=" mx-auto my-[1rem] w-7/12" onClick={(e) => handleItemClick(e, data)}>
                                <Link to={verified && data.id !== 10 && data.id !== "10" ?`/${data.id}`:""}>
                                <div className={showLoader ? "border-2 bg-smoke-lighter rounded" : width > 425 ? "w-[82%] mx-auto"  : null} ><img className="w-full h-full"  onLoad={() =>  setImageState(value => value + 1)} style={{width: "20em",height: "6.5em"}} src={data.image}   /></div>
                                    <div className={` ${theme === 'red' ?  "text-black": "text-white"} font-bold `}>{data.title}</div>
                                </Link>
                            </div>
                        )
                    })
                }
            </div>
            {showSermonLangModal && languageModalData && (
                <SermonLanguageModal 
                    languageData={languageModalData} 
                    onClose={() => setShowSermonLangModal(false)} 
                />
            )}
        </div>
    )
}